@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.section-header {
  background: @multi-check-dropdown--section-header--background-color;
  font-size: 13px;
  padding: 10px;
  border-bottom: 1px solid @multi-check-dropdown--section-header--border-color;
  line-height: 1.1;
  cursor: default;
}

.dropdown-menu {
  width: 100%;
}

.toggler {
  width: 100%;
  min-height: 32px;
  border: 1px solid @multi-check-dropdown--toggler--border-color;
  background-color: @multi-check-dropdown--toggler--background-color;
  color: @multi-check-dropdown--toggler--text-color;
  font-size: 14px;

  &:hover,
  &:active {
    border-color: @multi-check-dropdown--toggler--hover--border-color;
    box-shadow: none;
    background: none;
  }
}

.section {
  &:not(:first-child) {
    border-top: 1px solid @multi-check-dropdown--section--border-color;
  }
}

.dropdown-items {
  max-height: 200px;
  overflow-x: scroll;
}

.dropdown-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 36px;
  padding: 0 10px;
  font-size: 14px;
}

.close-button {
  margin-left: 10px;
}

.checkbox {
  display: inline;
  padding-right: 8px;
}
